require('./resetPassword.less');

var pageConfig = window.pageConfig;
var ajax = require('@enhancer/fe-util-ajax');
var resetPassword = require('./resetPassword.html');
var locale = require('../../i18n');
var app = require('../../app/app');
var util = require('../../app/util');

function init() {
  var token = util.getUrlParam('token');
  var mobile = util.getUrlParam('mobile');

  if (!mobile && !token || mobile && token) {
    window.location.href = '/';
  }

  if (!util.isMobile(mobile)) {
    mobile = '';
  }

  var html = resetPassword({
    locale: locale(),
    actionUrl: '/resetPassword',
    showCode: !!mobile
  });

  $('.user-center-wrapper').append(html);
  //$('#error').css('display', 'block');

  function checkPassword(ele, next) {
    var val = ele.val();
    if (util.isPassword(val)) {
      ele.removeClass('error');
      next && next();
    } else {
      ele.next('label').text(locale('passwordLength'));
      ele.addClass('error');
    }
  }


  if (mobile) {
    var sms;
    try {
      sms = localStorage.getItem('smsCode');
      if (sms) {
        localStorage.removeItem('smsCode');
        getActiveCode($('#getActiveCode'))
      }
    } catch(e) {
    }
  } else if (token) {
    $('input[name=token]').val(token);
  }

  $('#password').blur(function() {
    checkPassword($(this));
  }).focus(function() {
    $(this).removeClass('error');
  });

  function doSubmit(type) {
    var data = {
      password: $('#password').val().trim()
    };
    if (type === 'mobile') {
      data.account = mobile;
      data.mobileCode = $('#mobile-code').val().trim();
      data.type = 'mobile';
    } else if (type === 'email') {
      data.token = token;
      data.type = 'email';
    }
    ajax({
      url: `/api/resetPassword`,
      type: 'POST',
      data: data
    }, function(ret) {
      if (ret.success) {
        util.show(locale('resetSuccess'), 'success', function() {
          window.location.href = `/login`; ////
        });
      } else {
        util.show(ret.message, 'error');
      }
    });
  }
  $('.resetpwd-form button.submit').click(function(e) {
    e.preventDefault();

    checkPassword($('#password'), function() {
      if (mobile) {
        checkMobileCode($('#mobile-code'), function() {
          $('input[name=account]').val(mobile);
          //$('.resetpwd-form').submit();
          doSubmit('mobile');
        });
      } else {
        //$('.resetpwd-form').submit();
        doSubmit('email');
      }
    });
  });

  var checkTimer;

  function checkMobileCode(ele, next) {
    var code = ele.val().trim();
    if (util.isActiveCode(code)) {
      next && next();
    } else {
      ele.next('label').text(locale('mobileCodeInvalid'))
      ele.addClass('error');
    }
  }
  $('#mobile-code').blur(function() {
    checkTimer = setTimeout(() => {
      checkMobileCode($(this));
    }, 100);
  }).focus(function() {
    $(this).removeClass('error');
  });

  function getActiveCode(ele) {
    if (util.isMobile(mobile)) {
      util.getActiveCode(ele, mobile);
    }
  }

  $('#getActiveCode').click(function(e) {
    e.preventDefault();
    getActiveCode($(this));
  });


  var errorMsg = $('#error').text();
  if (errorMsg) {
    util.show(errorMsg, 'error')
  }
}
util.setCookie('v', '1');
init();


// WEBPACK FOOTER //
// ./src/pages/resetPassword/resetPassword.js